import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { getInitials } from "@/hooks/getInitials";
import { ArrowLeft, MapPin, Loader2, User } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MyProfile from "./userProfile/myProfile";
import { UpdatePassword } from "./userProfile/updatePassword";
import axios from "axios";
import { toast } from "sonner";
import { set } from "date-fns";
import { API } from "@/App";


const UserProfile = () => {
  const navigate = useNavigate();
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [address, setAddress] = useState("");
  const [fetchingLocation, setFetchingLocation] = useState(false);
  const [profile, setProfile] = useState({
    fullName: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).name : "",
    email: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).email : "",
    phone: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).phone : "",
    organization: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).organization : "",
    address: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).address : "",
    city: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).city : "",
    zipCode: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).zipCode : "",
    UserLocationInfo: { }
  });
  const[passwordData, setPasswordData] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: ""
  })

  const fetchCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }

    setFetchingLocation(true);
    
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ latitude, longitude });
        
        // Reverse geocode to get address using Google Maps API
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();
          
          if (data.results && data.results[0]) {
            setProfile((prevProfile) => ({
              ...prevProfile,
              address: data.results[0].formatted_address,
              // Backend expects a single dict (ProfileUpdateRequest.UserLocationInfo),
              // not the full results array — send the best (first) match.
              UserLocationInfo: data.results[0]
            }));
          }
        } catch (error) {
          console.error("Error fetching address:", error);
        }
        
        setFetchingLocation(false);
      },
      (error) => {
        console.error("Error getting location:", error);
        alert("Unable to retrieve your location");
        setFetchingLocation(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  };

  const handleUpdateMyProfile = async (e) => {
    // Implement API call to update profile information
    e.preventDefault();
    const data ={
        "name": profile.fullName,
        "email":profile.email,
        "phone":profile.phone, 
        "organization":profile.organization, 
        "address":profile.address, 
        "city":profile.city,
        "zipCode":profile.zipCode,
        "location":{
            "latitude": location.latitude,
            "longitude": location.longitude
        },
        "UserLocationInfo": profile.UserLocationInfo
    }
    await axios.put(`${API}/users/profile`, data)
      .then((response) => {
        // Optionally update localStorage with new profile info
        const updatedUser = { ...JSON.parse(localStorage.getItem("user")), ...profile };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        toast.success("Profile updated successfully!");
        setProfile(updatedUser);
      })
      .catch((error) => {
        console.error("Error updating profile:", error);
        toast.error("Failed to update profile. Please try again.");
      });
}
const handleUpdateMyPassword = async (e) => {
  // Implement API call to update profile information
  e.preventDefault();
  await axios.put(`${API}/users/change-password`, passwordData)
    .then((response) => {
      toast.success("Password updated successfully!");
       localStorage.clear();
      navigate('/');
    })
    .catch((error) => {
      console.error("Error updating password:", error);
      toast.error("Failed to update password. Please try again.");
    });
}

  return (
    <div className="min-h-screen bg-white" data-testid="carpool-page">
      <div className="pt-12 pb-12 px-6 max-w-7xl mx-auto">
        <Button
          data-testid="back-to-dashboard"
          onClick={() => navigate("/dashboard")}
          variant="ghost"
          className="mb-6 text-[#1A3C34] hover:bg-[#F5F2EB] rounded-full"
        >
          <ArrowLeft className="mr-2" size={20} />
          Back to Dashboard
        </Button>

        <div className="fade-in">
          <div className="mb-8">
            <h1 className="text-4xl lg:text-5xl font-bold text-[#1A3C34] mb-4">Carpool Network</h1>
            <p className="text-xl text-gray-600">
              Update your profile information and manage your carpool preferences here. You can also view your past bookings and upcoming reservations.
            </p>
          </div>
        </div>

        <Tabs defaultValue="profile" className="w-full mt-6 mb-6">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-8">
            <TabsTrigger value="profile" className="text-[#1A3C34] data-[state=active]:border-[#1A3C34] data-[state=active]:border-b-2 data-[state=active]:font-semibold">
              Profile
            </TabsTrigger>
            <TabsTrigger value="updatePassword" className="text-[#1A3C34] data-[state=active]:border-[#1A3C34] data-[state=active]:border-b-2 data-[state=active]:font-semibold">
              Update Password
            </TabsTrigger>
          </TabsList>
           <TabsContent value="profile">
             <MyProfile profile={profile} setProfile={setProfile} fetchCurrentLocation={fetchCurrentLocation} fetchingLocation={fetchingLocation} handleUpdateMyProfile={handleUpdateMyProfile} />
           </TabsContent>
           <TabsContent value="updatePassword">
             <UpdatePassword passwordData={passwordData} setPasswordData={setPasswordData} handleUpdateMyPassword={handleUpdateMyPassword} />
           </TabsContent>
        </Tabs>
        {/* User Profile Section */}
      
      </div>

    </div>
  );
};

export default UserProfile;